import { Stack, Typography } from "@mui/material";
import ProductAccordion from "./ProductAccordion";
import { ISkuDetail } from "../../../models/ISkuDetail";
import { typo } from "../../../assets/fonts/font";
import NutritionFact from "./NutritionFact";

interface ProductAccordionListProps {
  skuDetails: ISkuDetail;
}

const ProductAccordionList = ({ skuDetails }: ProductAccordionListProps) => {
  return (
    <Stack sx={{ backgroundColor: "inherit" }}>
      <ProductAccordion title="Ingredients">
        <Typography sx={{ ...typo.bodyContent, whiteSpace:"pre-line" }} component="span">
          {skuDetails.ingredients?.toString() || ""}
        </Typography>
      </ProductAccordion>
      <ProductAccordion title="Allergens">
        <Typography sx={{ ...typo.bodyContent, whiteSpace:"pre-line" }} component="span">
          {skuDetails.allergen?.toString() || ""}
        </Typography>
      </ProductAccordion>
      <ProductAccordion title="Nutrition Facts">
        <Typography sx={{ ...typo.bodyContent, whiteSpace:"pre-line" }} component="span">
          {skuDetails.nutrition && (
            <NutritionFact nutritionFact={skuDetails.nutrition} />
          )}
        </Typography>
      </ProductAccordion>
      <ProductAccordion title="Storage Information">
      <Typography sx={{ ...typo.bodyContent, whiteSpace: "pre-line" }} component="span">
        {skuDetails.storage_info?.toString() || ""}
      </Typography>
    </ProductAccordion>
    </Stack>
  );
};

export default ProductAccordionList;
